import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';


import { useLocation, useNavigate } from 'react-router-dom';
// @mui
import { styled, alpha } from '@mui/material/styles';
import { Box, Link, Button, Drawer, Typography, Avatar, Stack } from '@mui/material';
// mock
// import account from '../../../_mock/account';
// hooks
import useResponsive from '../../../hooks/useResponsive';
// components
import Logo from '../../../components/logo';
import Scrollbar from '../../../components/scrollbar';
import NavSection from '../../../components/nav-section';
//
import navConfigKo from './configKo';
import navConfigMd from './configMd';
import navConfigAll from './configAll';

import { variables } from '../../../Variables';
// ----------------------------------------------------------------------

const NAV_WIDTH = 280;

const StyledAccount = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: alpha(theme.palette.grey[500], 0.12),
}));

// ----------------------------------------------------------------------

Nav.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
};

export default function Nav({ openNav, onCloseNav }) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const isDesktop = useResponsive('up', 'lg');

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const [account, setUser] = useState([{}]);


  const [loginuserDetailId, setloginuserDetailId] = useState();
  const [userrole, setuserrole] = useState();
  const [userName, setuserName] = useState();
  const [userImage, setuserImage] = useState();
  const [loginuserType, setloginuserType] = useState();

  const chkUserLogin = () => {
    const b = JSON.parse(localStorage.getItem('mYLog'));
    console.log({ b });
    if (b === null) {
      navigate('/login', { replace: true });

    }
    else {
      setuserName(JSON.parse(localStorage.getItem('mYLog')).displayName)
      setuserImage(JSON.parse(localStorage.getItem('mYLog')).ProfileImage)
      setloginuserDetailId(JSON.parse(localStorage.getItem('mYLog')).UId)
      setuserrole(JSON.parse(localStorage.getItem('mYLog')).role)
      setloginuserType(localStorage.getItem('userTypeId'));
      
    }

  };
  useEffect(() => {
    chkUserLogin();
  }, []);



  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column' },
      }}
    >
      <Box sx={{ px: 2.5, py: 3, display: 'inline-flex' }}>
        <Logo />
      </Box>

      <Box sx={{ mb: 5, mx: 2.5 }}>
        <Link underline="none">
          <StyledAccount>
            <Avatar src={`/assets/images/avatars/${userImage}`} alt="photoURL" />

            <Box sx={{ ml: 2 }}>
              <Typography variant="subtitle2" sx={{ color: 'text.primary' }}>
                {userName}
              </Typography>

              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {userrole}
              </Typography>
            </Box>
          </StyledAccount>
        </Link>
      </Box>

      <NavSection data={loginuserDetailId <= 3 && navConfigAll || (loginuserType === "4" && navConfigAll || (loginuserDetailId === 9 && navConfigMd || navConfigKo))} />
      

      <Box sx={{ flexGrow: 1 }} />

      <Box sx={{ px: 2.5, pb: 3, mt: 10 }}>
        <Stack alignItems="center" spacing={3} sx={{ pt: 5, borderRadius: 2, position: 'relative' }}>
          <Box
            component="img"
            src="/assets/logo3.png"
            sx={{ height: 75, position: 'absolute', top: -50 }}
          />

          <Box sx={{ textAlign: 'center' }}>
            <Typography gutterBottom variant="h6">
              Get more?
            </Typography>

            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              Call: 9500573368 {loginuserType}
            </Typography>
          </Box>

          <Button href="http://nalam.co.in" target="_blank" variant="contained">
            New Nalam Pharmacy
          </Button>
        </Stack>
      </Box>
    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV_WIDTH },
      }}
    >
      {isDesktop ? (
        <Drawer
          open
          variant="permanent"
          PaperProps={{
            sx: {
              width: NAV_WIDTH,
              bgcolor: 'background.default',
              borderRightStyle: 'dashed',
            },
          }}
        >
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: { width: NAV_WIDTH },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}
